/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum AdditionalChargeWaivedCause {
  Bug = "bug",
  Grace = "grace",
  ChallengedWithCarrier = "challenged_with_carrier",
}

export function instanceOfAdditionalChargeWaivedCause(value: any): boolean {
  for (const key in AdditionalChargeWaivedCause) {
    if (
      Object.prototype.hasOwnProperty.call(AdditionalChargeWaivedCause, key)
    ) {
      if (
        AdditionalChargeWaivedCause[
          key as keyof typeof AdditionalChargeWaivedCause
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function AdditionalChargeWaivedCauseFromJSON(
  json: any,
): AdditionalChargeWaivedCause {
  return AdditionalChargeWaivedCauseFromJSONTyped(json, false);
}

export function AdditionalChargeWaivedCauseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AdditionalChargeWaivedCause {
  return json as AdditionalChargeWaivedCause;
}

export function AdditionalChargeWaivedCauseToJSON(
  value?: AdditionalChargeWaivedCause | null,
): any {
  return value as any;
}

export function AdditionalChargeWaivedCauseToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): AdditionalChargeWaivedCause {
  return value as AdditionalChargeWaivedCause;
}
